module.exports = __webpack_public_path__ + "static/media/hotbid-three.ed63b287.png";